import firebase from "firebase/app";

import { Header } from "semantic-ui-react";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { db } from "astrid-firebase";
import updateOrganization from "astrid-firestore/src/api/organizations/updateOrganization";
import { useCollectionData } from "astrid-firestore/src/hooks/index";

import OpenButton from "../../../ui/components/OpenButton/OpenButton";

import useHasRight from "../../../authorization/hooks/useHasRight";
import Table from "../../../tables/components/Table";

import PublisherExportPresetForm from "../../components/PublisherExportPreset/PublisherExportPresetForm";

export default function ExportPresetSettingsView({ publisher }) {
	const { t } = useTranslation();
	const hasRight = useHasRight();
	const [selectedPreset, setSelectedPreset] = useState(null);

	const [exportPresets] = useCollectionData(db.collection("exportPresets").where("deleted", "==", false));

	const tableData = Object.entries(publisher.exportPresets || {}).map(([id, settings]) => {
		const preset = exportPresets?.find((p) => p.id === id);
		return {
			id,
			name: preset?.name || id,
			actions: settings.actions,
		};
	});

	const getDropdownMenuOptions = (row) => [
		{
			text: t("remove", "Remove"),
			action: () =>
				updateOrganization(firebase, publisher.ref, {
					[`exportPresets.${row.id}`]: firebase.firestore.FieldValue.delete(),
				}),
		},
	];

	return (
		<>
			<Header as="h3">{t("exportPresets", "Export presets")}</Header>

			{hasRight("distributions.addPresets") && (
				<OpenButton text={t("addExportPreset", "Add export preset")}>
					{({ setOpen }) => (
						<PublisherExportPresetForm publisher={publisher} onClose={() => setOpen(false)} />
					)}
				</OpenButton>
			)}

			<Table
				data={tableData}
				columns={[{ id: "name", Header: t("name", "Name") }]}
				onClick={hasRight("distributions.addPresets") ? (row) => setSelectedPreset(row) : undefined}
				getDropdownMenuOptions={hasRight("distributions.addPresets") ? getDropdownMenuOptions : undefined}
			/>

			{selectedPreset && (
				<PublisherExportPresetForm
					publisher={publisher}
					editData={selectedPreset}
					onClose={() => setSelectedPreset(null)}
				/>
			)}
		</>
	);
}
